import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { PareceresColumns } from './columns/_columns'
import { InterconsultaSolicitanteList } from '../core/_models'
import { useT } from '_metronic/i18n/Metronici18n'
import { useEscopoPareceres } from '../core/escopoPareceres'

export const PareceresTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()
  const escopo = useEscopoPareceres()

  const columns = useMemo(() => PareceresColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhum parecer encontrado'
      description='Revise os filtros aplicados.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : escopo === 'equipe' ? (
    <TableEmptyState
      title='Nenhum parecer na equipe'
      description='As interconsultas solicitadas na instituição aparecem aqui.'
    />
  ) : (
    <TableEmptyState
      title='Nenhum parecer solicitado'
      description='Use “Solicitar parecer” para pedir uma interconsulta.'
    />
  )

  return (
    <CustomTable<InterconsultaSolicitanteList>
      id='kt_table_pareceres'
      ariaLabel='Pareceres'
      itemLabel={{ singular: 'parecer', plural: 'pareceres' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
